import { ACTION_TYPES } from '../../../utils/Constants';
import { myLog } from '../../../utils/Utility';
import Client from '../../../utils/ClientVOIM';
import URL from '../../../utils/URL';
import { RESPONSE_CONSTANT } from '../../../utils/ResponseConstant';

/**
 * Get Dashboard Details
 * @param {Function} callBack
 */
export const getDashboardDetails = (callBack) => {
    return function (dispatch) {
        Client.get(URL.COMMON_ENDPOINT.DASHBOARD_DETAILS, null, true)
            .then((response) => {
                callBack(response);
                if (response.code === RESPONSE_CONSTANT.SUCCESS_CODE) {
                    dispatch({
                        type: ACTION_TYPES.PHYSICIAN.DASHBOARD,
                        payload: response.response,
                    });
                }
            })
            .catch((error) => {
                myLog('====DashDetails error===????', error);
                callBack(false);
            });
    };
};

// educator dashboard appointment list api
export const getAppointmentDetails = (callBack) => {
    return function (dispatch) {
        Client.get(URL.COMMON_ENDPOINT.DASHBOARD_APPOINTMENT_DETAILS, null, true)
            .then((response) => {
                callBack(response);
                if (response.code === RESPONSE_CONSTANT.SUCCESS_CODE) {
                    dispatch({
                        type: ACTION_TYPES.PHYSICIAN.DASHBOARD_APPOINTMENT,
                        payload: response.response,
                    });
                }
            })
            .catch((error) => {
                myLog('====DashDetails error===????', error);
                callBack(false);
            });
    };
};
